export enum FcaResultKind {
  Register = 'register',
  Existing = 'existing',
  NotFound = 'not-found',
}
